import { updateLinksAttributes } from '../utils.js';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widgetHTML = $(`#${widgetName}`);

  function createCustomSeo(widgetData) {
    const $seo = $widgetHTML.find('.card-widget-item');
    const firstItem = widgetData?.[0];

    if (!firstItem) {
      $widgetHTML.remove();
      return;
    }

    const { Title, Description, URL } = firstItem;

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      ${Description ? `<div class="seo-description"><p>${Description}</p></div>` : ''}
      ${URL == null ? '' : `<a href="${URL}" class="button" ${updateLinksAttributes(URL, Title)}>More</a>`}
    `);
  }

  return saffire.widgets.cardWidget($widgetHTML, {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: false,
    moreButton: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items);
      } else {
        $widgetHTML.remove();
      }
    },
    itemsPerPanel: 1,
    hasImages: false,
    lazyLoadImages: false,
    imageIsBackground: false,
    maxItemsVisible: 1,
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: false,
  });
}
